module.exports = __webpack_public_path__ + "img/storage46.1f8813be.jpg";